import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()
    const {canAddNodeToIsrfNew, addNodeToIsrfNew} = map.commands
    const nodes = canAddNodeToIsrfNew(selectedNodes)

    return {
        disabled: 0 === nodes.length,
        key: 'add-node-to-isrf-new',
        label: '新版加入软件SPEC单',
        onClick: () => addNodeToIsrfNew(nodes),
    }
}
